// extracted by mini-css-extract-plugin
export default {"input-group":"input_input-group__15L3G"};